import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";

import {
  RestoreAccessPage,
  LoginPage,
  RestoreDonePage,
  RestorePasswordPage,
  InviteUserPage,
} from "login_section/pages";
import { AuthLayout } from "login_section/layouts";
import StatisticsChildrenRoutes from "statistics_host/statisticsRoutes";
import ProjectsChildrenRoutes from "projects_host/projectsRoutes";
import GeneralSettingsRoutes from "general_settings_section/generalSettingsRoutes";
import TestManagerRoutes from "test_manager_section/testManagerRoutes";
import SchedulerRoutes from "scheduler_section/SchedulerRoutes";
import WikiRoutes from "wiki_section/WikiRoutes";
import RdpRoutes from "rdp_section/RdpRoutes";
const UsersLayouts = () => import("statistics_host/UsersLayouts");
const ProjectLayouts = () => import("projects_host/ProjectLayouts");
const GeneralSettings = () =>
  import("general_settings_section/GeneralSettings");
const TestManager = () => import("test_manager_section/TestManager");
const Scheduler = () => import("scheduler_section/Scheduler");
const Wiki = () => import("wiki_section/Wiki");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "default",
    redirect: { name: "projects" },
    meta: {
      title: "Проекты",
    },
    children: [
      {
        path: "/",
        name: "auth",
        component: AuthLayout,
        meta: {
          isAuth: false,
          roles: [],
        },
        children: [
          {
            path: "login",
            name: "login",
            component: LoginPage,
          },
          {
            path: "restore-access",
            name: "restore-access",
            component: RestoreAccessPage,
          },
          {
            path: "restore-done/:email",
            name: "restore-done",
            component: RestoreDonePage,
          },
          {
            path: "restore-password",
            name: "restore-password",
            component: RestorePasswordPage,
          },
          {
            path: "activate-account/:token",
            name: "activate-account",
            component: InviteUserPage,
            meta: {
              isAuth: false,
              roles: [],
            },
          },
        ],
      },

      {
        path: "/users",
        name: "users",
        component: UsersLayouts,
        children: StatisticsChildrenRoutes,
        meta: {
          title: "Пользователи",
          name: "Администратор. Пользователи",
          isAuth: true,
          roles: [TypeRoles.ProjectAdmin, TypeRoles.Owner],
          middleware: [checkTeam],
        },
      },
      {
        path: "/projects",
        name: "projects",
        component: ProjectLayouts,
        children: ProjectsChildrenRoutes,
        redirect: { name: "projects-list" },
        meta: {
          name: "Администратор. Проекты",
          isAuth: true,
          roles: [],
        },
      },
      {
        path: "/settings",
        name: "settings",
        component: GeneralSettings,
        children: GeneralSettingsRoutes,
        meta: {
          title: "Настройки",
          name: "Настройки",
          isAuth: true,
        },
      },
      {
        path: "/test-manager",
        name: "test-manager",
        component: TestManager,
        children: TestManagerRoutes,
        redirect: { name: "test-manager-projects" },
        meta: {
          name: "Менеджер тестов",
          isAuth: true,
          roles: [],
        },
      },
      {
        path: "/scheduler",
        name: "scheduler",
        component: Scheduler,
        children: SchedulerRoutes,
        redirect: { name: "scheduler-projects" },
        meta: {
          name: "Шедулер",
          isAuth: true,
          roles: [],
        },
      },
      {
        path: "/wiki",
        name: "wiki",
        component: Wiki,
        children: WikiRoutes,
        redirect: { name: "wiki-projects" },
        meta: {
          name: "Wiki",
          isAuth: true,
          roles: [],
        },
      },
    ],
  },
];

const router = createRouter({
  routes: routes,
  history: createWebHistory(),
});

import ApiService from "@/shared/api";
import UserResponse from "@/shared/api/Main/dataSource/api/users/base/i-service/models/UserResponse";

import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";
import TypeRoles from "@/shared/api/Main/dataSource/api/pm/authorization/models/enums/TypeRoles";
import { checkTeam } from "./middleware";

const api = new ApiService();

let user: UserResponse;

let isInited = false;

let isHasRdpAccess = false;

router.beforeEach(async (to, _, next) => {
  if (!!to.meta.title) {
    document.title = to.meta.title as string;
  }
  // Любая страница доступная без авторизации за исключении логина
  if (
    !to.meta.isAuth &&
    [
      "login",
      "restore-access",
      "activate-account",
      "restore-password",
      "restore-done",
    ].find((x) => x == to.name)
  ) {
    return next();
  }

  // Если пользователь не авторизован и не было попытки получения информации о пользователе
  if (!user && !isInited) {
    try {
      const resp = await api.Main.UsersService.getCurrentUserAsync();
      user = resp;
    } catch (err) {
      console.error(err);
      user = undefined;
      isInited = true;
      return next({ name: "login" });
    }
    isInited = true;
  }
  // Если пользователь авторизован и страница логин - тогда редирект на projects
  if (
    user &&
    [
      "auth",
      "login",
      "restore-access",
      "activate-account",
      "restore-password",
      "restore-done",
    ].find((x) => x == to.name)
  ) {
    return next({ name: "projects" });
  }

  const allowedRoles = to.meta.roles as UserRoleEnum[];
  console.log("allowedRoles", allowedRoles);
  if (
    allowedRoles?.length &&
    !CurrentUser.Roles?.some((r) => allowedRoles.includes(r))
  ) {
    return next("/");
  }

  //Проверка переходов
  const middlewares = to.meta.middleware as ((
    route: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => Promise<boolean>)[];
  if (middlewares) {
    for (const middleware of middlewares) {
      if (!(await middleware(to, next))) return;
    }
  }

  next();
});

export default router;
